import { render, staticRenderFns } from "./ContribFornecedorCadastro.vue?vue&type=template&id=4e32f998&"
import script from "./ContribFornecedorCadastro.vue?vue&type=script&lang=js&"
export * from "./ContribFornecedorCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports